import React from 'react';
var AsyncFileView = React.lazy(function () {
  return import('./FileContentViewer');
});

var Spinner = function Spinner() {
  return React.createElement("span", null, "Loading");
};
/**
 * @extends {React.Component<import('./types').FileViewProps> }
 */


var FileView = function FileView(props) {
  return React.createElement(React.Suspense, {
    fallback: React.createElement(Spinner, null)
  }, React.createElement(AsyncFileView, props));
};

export default FileView;